var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgYellowArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 32.4938V7.21929C12.5013 6.38585 11.83 5.71307 10.9985 5.71307C10.167 5.71307 9.4958 6.38585 9.4958 7.21929V32.4938C9.4958 33.3272 10.167 34 10.9985 34C11.83 34 12.5013 33.3272 12.5013 32.4938Z",
    fill: "#D78016"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L0 11.849H22L11 0Z",
    fill: "#D78016"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYellowArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/yellow-arrow.605af323.svg";
export { ForwardRef as ReactComponent };